import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px 36px;
  min-width: 424px;
`

export const InputsWrapper = styled.div`
  display: flex;
  gap: 24px;
  width: 200px;
`

export const InputButtonContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-end;
  align-self: flex-start;
  width: 570px;
  margin: 24px 0px 80px;

  button {
    position: absolute;
    width: 51px;
    height: 54px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-left: 10px;
    border-radius: 0px 10px 10px 0px;

    span {
      width: 30px;
      height: 30px;
    }

    svg {
      height: 30px;
      width: 30px;

      path {
        height: 30px;
        width: 30px;
        fill: white;
        opacity: 1;
      }
    }
  }
`
